// @PARAM value
// RETURNS value with px appended to the string
function toPX(value) {
  return value + 'px';
}

// Vanilla JS implementation of jQuery's $(function() {...} )
// In other words, do this when the document is loaded
function ready(fn) {
  if (
    document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'
  ) {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

function dispatchScriptLoadedEvent(script) {
  const event = new Event(`script-loaded:${script}`);
  ready(function () {
    document.dispatchEvent(event);
  });
}

function ujsAjaxParams(ujsEvent) {
  return {
    data: ujsEvent.originalEvent.detail[0],
    status: ujsEvent.originalEvent.detail[1],
    xmlHttpRequest: ujsEvent.originalEvent.detail[2],
  };
}

export { toPX, dispatchScriptLoadedEvent, ready, ujsAjaxParams };
